import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AlertModule, ElementSize, SharedDirectivesModule } from 'mbs-ui-kit';
import { DirectivesModule } from '../../directives/directives.module';

@UntilDestroy()
@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  standalone: true,
  styleUrls: ['page-header.component.scss'],
  imports: [CommonModule, DirectivesModule, SharedDirectivesModule, AlertModule]
})
export class PageHeaderComponent {
  @Input() fixed = true;

  @Output() sizeChanged = new EventEmitter<ElementSize>();
}
